<ng-container *ngIf="batches?.length">
  <samp [tooltip]="slotsTemplate" placement="left" container="body">{{
    batches|pluck:'slots_total'|sum }}</samp>
  <ng-container *ngIf="slotsActive">
    &nbsp;<samp class="text-success" [tooltip]="'SLOTS.ACTIVE_TOOLTIP'|translate" placement="left" container="body">{{ slotsActive }}</samp>
  </ng-container>
</ng-container>
<ng-template #slotsTemplate>
  <table class="tt-details">
    <tbody>
      <tr *ngFor="let d of details|keyvalue" class="tr-align-center">
        <td class="text-left">{{ d.key|translate }}</td>
        <td class="text-right">{{ d.value }}</td>
      </tr>
    </tbody>
  </table>
</ng-template>